import React from 'react';
import { WysiwygField } from '../../../components';

import './style.scss';

const TextBlock = ({ entity }) => {
  return (
    <div className="TextBlock">
      <WysiwygField
        property="schema:text"
        className="TextBlock__body"
        html={entity.getIn(['body', 0, 'processed'])}
      />
    </div>
  );
};

export default TextBlock;
